import {
  productRecommendations,
  productQuestions,
} from "../../mock/recommendations";

export default function useInputAdapter(
  answers,
  macallanWhiskies,
  answeredPages,
  level
) {
  let contentUrls = [],
    productCodes = [],
    answersCurrent = [],
    inputAdapterData = [],
    debugInfo = [];

  let questions = answeredPages;

  if (typeof questions !== "undefined" && typeof answers !== "undefined") {
    // loop each answered question question
    questions.forEach(function (page) {
      let answer = answers[page.crmId];
      if (page.crmId === "how_much_have_you_explored_the_world_of_whisky_") {
        answer = level;
      }

      if (answer === null || typeof answer === "undefined") return;

      answersCurrent.push(answer);

      if (typeof productQuestions[page.crmId] !== "undefined") {
        // whether the question is about the products

        if (Array.isArray(answer)) {
          Object.keys(answer).forEach(function (productKey) {
            productCodes.push({
              code: answer[productKey],
              verb: productQuestions[page.crmId],
            });
          });
        } else {
          productCodes.push({
            code: answer,
            verb: productQuestions[page.crmId],
          });
        }
      }

      if (typeof page.recommendations !== "undefined") {
        let recommendations = page.recommendations;

        Object.keys(recommendations).forEach(function (recommendationsKey) {
          if (
            recommendationsKey === answer.toString().replace(", ", "") ||
            recommendationsKey === "all" ||
            (Array.isArray(answer) && answer.includes(recommendationsKey))
          ) {
            Object.keys(recommendations[recommendationsKey]).forEach(function (
              recommendationKey
            ) {
              let recommendation =
                recommendations[recommendationsKey][recommendationKey];

              if (Array.isArray(recommendation)) {
                recommendation =
                  recommendation[
                    Math.floor(Math.random() * recommendation.length)
                  ];
              }
              debugInfo.push({
                question: page.crmId,
                answer: recommendationsKey,
                url: recommendation,
              });
              contentUrls.push(recommendation);
            });
          }
        });
      }
    });
  }

  inputAdapterData["answersCurrent"] = answersCurrent;
  inputAdapterData["debugInfo"] = debugInfo;
  inputAdapterData["contentUrls"] = contentUrls;

  let productArray = [];

  // getting product title and recommendations
  productCodes.forEach(function (product, productKey) {
    let recoMatrix = productRecommendations.find(
      (pr) => pr.code === product.code
    );

    let title = macallanWhiskies.find((mw) => mw.productCode === product.code);

    if (
      typeof recoMatrix?.recommendations === "undefined" ||
      typeof title?.label === "undefined"
    ) {
      return;
    }

    // loop each category and push as object to array
    Object.keys(recoMatrix.recommendations).forEach(function (
      recommendationsKey
    ) {
      let rec = recoMatrix.recommendations[recommendationsKey],
        productInfo = {
          parentTitle: title.label,
          verb: product.verb,
          category: recommendationsKey,
          url: rec,
        };

      productArray.push(productInfo);
    });
  });

  inputAdapterData["productCodes"] = productArray;

  return inputAdapterData;
}
